import React from "react"
import SEO from "../components/SEO"
import MenuPage from "../features/menu"
import { WEBSITE } from "../constants"

const Menu: React.FC = () => {
  return (
    <>
      <SEO
        title={`Menu | ${WEBSITE.TITLE}`}
        description="Khám phá menu đa dạng của TuTiMi với các loại trà sữa, cà phê, milo dầm và đồ uống tươi mát. Hương vị đặc biệt từ thiên nhiên."
        keywords="TuTiMi menu, trà sữa, cà phê, milo dầm, đồ uống, menu TuTiMi, trà trái cây"
      />
      <div className="px-4 py-6 sm:px-8 sm:py-8 lg:px-16 lg:py-12">
        <MenuPage />
      </div>
    </>
  )
}

export default Menu
